import { useRef } from "react";
import { toast } from "sonner";
import { API } from "@/lib/api";

export const createAuthFetch = (key) => (path, opts = {}) =>
  fetch(`${API}${path}`, { ...opts, headers: { "X-PL-Client": "web", "X-Admin-Key": key, ...(opts.body instanceof FormData ? {} : { "Content-Type": "application/json" }), ...(opts.headers || {}) } });

export const readJson = async (res) => {
  const data = await res.json().catch(() => ({}));
  if (Array.isArray(data?.detail)) data.detail = data.detail.map((d) => String(d.msg || "").replace(/^Value error, /, "")).filter(Boolean).join("; ") || "Invalid input";
  return data;
};

export const uploadMedia = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const res = await fetch(`${API}/media/upload`, { method: "POST", body: fd });
  const data = await readJson(res);
  if (!res.ok) throw new Error(data?.detail || "Upload failed");
  return data;
};

export const moveItem = (list, from, to) => {
  const n = [...list];
  const [m] = n.splice(from, 1);
  n.splice(to, 0, m);
  return n;
};

export const useListReorder = (authFetch) => {
  const dragCtx = useRef({ type: null, from: null });
  const handleDrop = async (type, list, setList, to, endpoint) => {
    const { type: t, from } = dragCtx.current;
    dragCtx.current = { type: null, from: null };
    if (t !== type || from === null || from === to) return;
    const arr = moveItem(list, from, to);
    setList(arr);
    try {
      await authFetch(endpoint, { method: "PUT", body: JSON.stringify({ ids: arr.map((x) => x.id) }) });
    } catch {
      toast.error("Could not save new order");
    }
  };
  return { dragCtx, handleDrop };
};
